'use client';

import type { FC } from 'react';
import { Suspense, lazy } from 'react';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import { useCustomerInformation } from '../../../../hooks/useCustomerInformation/useCustomerInformation';
import { LoginDialogComposed } from '../../../../LoginDialog/LoginDialogComposed/LoginDialogComposed';
import { Slot, type SlotProps } from '../Base/Slot.client';
import { useAccountLink } from '../../shared/useAccountLink';

const AccountPopoverContent = lazy(
  () => import(/* webpackChunkName: 'AccountPopoverContent' */ '../Base/AccountPopoverContent'),
);

export type AccountSlotProps = Pick<SlotProps, 'priority'>;

/** My account slot */
export const AccountSlot: FC<AccountSlotProps> = (props) => {
  const { customerInformation } = useCustomerInformation();
  const { lifeSupportForBasicallyDeadTenant } = useConfig();
  const { href, label } = useAccountLink();

  const { isMobile } = useDeviceType();

  return isMobile ? (
    <Slot
      {...props}
      useRouterLink={false}
      href={href}
      icon={<span className="icon-emp-user size-4" />}
      badgeCount={customerInformation?.newsCount ?? undefined}
      linkAriaLabel={label}
    />
  ) : (
    <LoginDialogComposed>
      {(openLoginDialog) => (
        <Slot
          {...props}
          useRouterLink={false}
          href={href}
          icon={<span className="icon-emp-user size-4" />}
          title={label}
          badgeCount={customerInformation?.newsCount ?? undefined}
        >
          {lifeSupportForBasicallyDeadTenant ? null : (
            <Suspense>
              <AccountPopoverContent onLogin={openLoginDialog} />
            </Suspense>
          )}
        </Slot>
      )}
    </LoginDialogComposed>
  );
};
